(function () {
    if (document.querySelector("#interactive-map-container")) {
        var mapboxgl = require("mapbox-gl/dist/mapbox-gl.js");

        const mapContainer = document.querySelector("#interactive-map-container");
        const startLng = mapContainer.dataset.startlng;
        const startLat = mapContainer.dataset.startlat;

        const map = new mapboxgl.Map({
            accessToken:
                "pk.eyJ1IjoicHJvamVrdHhhcnR3b3JrIiwiYSI6ImNsNTEwN3BmNjAxMHIzZW10Ym9henhxamoifQ.j3Qd-eBYh81zz5rsnSsXvQ",
            container: "interactive-map",
            style: "mapbox://styles/projektxartwork/cm9i5s3ih002101sb2v815qb7",
            center: [startLng, startLat], // starting position [lng, lat]
            zoom: 14.75, // starting zoom
        });

        const addMarker = (uri, title, icon, iconalt, lng, lat, type) => {
            const marker = new mapboxgl.Marker({ 
                element: createCustomMarkerElement(icon, iconalt, type) // z. B. anderer Stil für Typen
            });
            const minPopup = new mapboxgl.Popup();

            minPopup.setHTML(`
                <div class="interactive-map-info ${type}">
                    <img src="${icon}" alt="${iconalt}" width="40" height="40" />
                    <div class="headline text--md margin-top--sm margin-bottom--md">${title}</div>
                    <a
                        class="button text--xs"
                        href="${uri}"
                        alt="_self"
                        >
                        <svg
                            class="stroke--light"
                            xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 33 24.1"
                            height="20"
                            width="30"
                            >
                            <path d="M21,1.5l10.5,10.5-10.5,10.6M31.5,12H1.5"/>
                        </svg>
                        Infos lesen
                    </a>
                </div>
            `);
            marker.setPopup(minPopup);
            marker.setLngLat([lng, lat]);
            marker.addTo(map);
        };

        const createCustomMarkerElement = (icon, iconalt, type) => {
            const el = document.createElement("div");
            el.className = "custom-marker";
            el.innerHTML = `
                <div class="custom-marker--inner">
                    <img class="icon" src="${icon}" alt="${iconalt}" width="25" height="25" />
                    <img class="pin" src="/_Resources/Static/Packages/PX.Site/Images/marker-${type}.svg" width="50" height="50" />
                </div>
            `
            return el;
        };        

        const markers = JSON.parse(mapContainer.dataset.markers);

        const addMarkers = () => {
            Object.values(markers).forEach((marker) => {
                addMarker(
                    marker.uri,
                    marker.title,
                    marker.icon,
                    marker.iconalt,
                    marker.locationLng,
                    marker.locationLat,
                    marker.type
                );
            });
        };

        map.on("load", () => {
            addMarkers();
            map.resize();
        });
    }
})();
